export default "__VITE_ASSET__BKI06dpq__"